
export enum EAdsBussinesType {
  RENT = 'for-rent',
  SALE = 'for-sale',
  ALL = 'all'
}

export enum EAdsPropertyType {
  APARTMENT = 'apartment',
  HOUSE = 'house',
  ALL = 'all'
}

export type AdClassification =
  | 'cash_cow'
  | 'marketing'
  | 'compete_on_price'
  | 'not_worth'

export type NameAmenity =
  | 'has_parking_lot'
  | 'has_terrace'
  | 'has_pool'
  | 'has_garden'
  | 'has_yard'
  | 'has_gym'
  | 'has_multipurpose_all'
  | 'has_service_room'
  | 'has_furniture'
  | 'pets_allowed'
  | 'has_balcony'
  | 'has_multipurpose_hall'
  | 'has_two_parking_lots_prob'

export interface AmenityReport {
  amenity: NameAmenity
  hasAmenity: number
  amenityProbability: number
}
export interface DataListingReport {
  addressMunicipality: string
  addressNeighborhood: string
  addressState: string
  addressNumber: string
  addressStreet: string
  numBedrooms: number
  numBathrooms: number
  price: number
  title: string
  numParkingLots: number | null
  propertyType: EAdsPropertyType
  propertyPriceUsd?: number
  listingType: EAdsBussinesType
  coverImage: string
  photos: string[]
}
export interface DataReport extends DataListingReport {
  adClassification: AdClassification
  liquidityAdPoints: number
  liquidityZonePoints: number
  propertyPrice: number
  propertyPriceM2: number
  priceM2Mean: number
  priceM2Std: number
  priceMean: number
  roiPoints?: number
  differentiationPoints: number
  comparablesPriceIntervals: IComparablesPriceIntervals
  comparablesPriceM2Intervals: IComparablesPriceIntervals
  amenities: AmenityReport[]
  latitude: number
  longitude: number
  numPropertiesOnMarket: number
  predictionPriceRent: number
  predictionPriceSale: number
  uberOptionsPoints?: 0 | 1 | 2 | 3 | 4 | 5
  uberPricesPoints?: 0 | 1 | 2 | 3 | 4 | 5
}

export interface IComparables {
  addressMunicipality: string
  addressNeighborhood: string
  addressState: string
  addressStreet: string
  builtYear: number
  dissimilarityToTarget: number
  isNewPropertyProb: number
  numBathrooms: number
  numBedrooms: number
  numParkingLots: number
  pricePerSquareMeter: number
  price: number
  propertyCode: string
  propertyId: string
  surfaceTotal: number
  terrainSurface: number
  urlAd: string[]
  title: string[]
}

export interface IResponseComparables {
  data: {
    forSaleComparables?: IComparables[]
    forRentComparables?: IComparables[]
  }
  message: string
}

export interface IResponseReport {
  property: IReportProperty
  forSaleAdMetrics: IForSaleAdMetrics
}

export interface IForSaleAdMetrics {
  adClassification: string
  amenities: Amenity[]
  differentiationPoints: number
  liquidityAdPoints: number
  liquidityZonePoints: number
  numPropertiesOnMarket: number
  priceM2Mean: number
  priceM2Std: number
  priceMean: number
  propertyPrice: number
  propertyPriceM2: number
  uberOptionsPoints: number
  uberPricesPoints: number
}

export interface Amenity {
  amenity: string
  hasAmenity: number
  amenityProbability: number
}

export interface IReportProperty {
  addressMunicipality: string
  addressNeighborhood: string
  addressNumber: number
  addressState: string
  addressStreet: string
  amenities: string[]
  latitude: number
  longitude: number
  numBathrooms: number
  numBedrooms: number
  numParkingLots: number
  propertyType: string
  title: null
  predictionPriceSale?: number
  predictionPriceRent?: number
  predictionPricePerSquareMeterSale: number
}
export interface IPropertyPhoto {
  indoorProb: number
  listingId: string
  order: number
  photo: string
}
export type IUberPoints = 0 | 1 | 2 | 3 | 4 | 5

export interface IComparablesPriceIntervals {
  intervals: number[][]
  minValue: number
  maxValue: number
  observations: number[]
}
export interface IPropertyAdvance {
  addressMunicipality: string
  addressNeighborhood: string
  addressNumber: number
  addressState: string
  addressStreet: string
  amenities: string[]
  latitude: number
  longitude: number
  numBathrooms: number
  numBedrooms: number
  numParkingLots: number
  propertyType: string
  title: string
}

export interface IAppraisalReportValues {
  value: number
  valuePerSqm: number
  upperValueRangePerSqm: number
  lowerValueRangePerSqm: number
  upperValueRange: number
  lowerValueRange: number
}

export interface ICapitalGain {
  currentCapGain: number
  capGainTimeSeries: Record<string, number>
  currentPrice: number
  m2PricePerQuarter: Record<string, number>
}

export interface IAppraisalReport {
  forSale: IAppraisalReportValues
  forRent: IAppraisalReportValues
  capitalGain: ICapitalGain
}

export interface IOperablesRanges {
  roLb: number
  roUb: number
  hotPriceRecomendation: number
}
export interface IRateMyAdMetric {
  adClassification: string
  amenities: AmenityReport[]
  differentiationPoints: number
  liquidityAdPoints: number
  liquidityZonePoints: number
  numPropertiesOnMarket: number
  priceM2Mean: number
  priceM2Std: number
  priceMean: number
  propertyPrice: number
  propertyPriceM2: number
  uberOptionsPoints: IUberPoints
  uberPricesPoints: number
  comparablesPriceIntervals: IComparablesPriceIntervals
  comparablesPriceM2Intervals: IComparablesPriceIntervals
}
export interface IReportAdvance {
  appraisalReport: IAppraisalReport | null
  comparables: {
    forSaleComparables?: IComparables[] | null
    forRentComparables?: IComparables[] | null
  }
  operableRanges: IOperablesRanges | null
  property: IPropertyAdvance
  rateMyAdMetrics: {
    forSale?: IRateMyAdMetric
    forRent?: IRateMyAdMetric
  } | null
}

export interface IDataAdvance
  extends Partial<IRateMyAdMetric>,
    Partial<IAppraisalReportValues>,
    Partial<Omit<IPropertyAdvance, 'amenities'>> {
  comparables?: IComparables[]
}
